
<template>
	<page>
		<module enable-flex>
			<c-table ref="list" height="grow" :paging="false">
				<c-table-column
					label="版本名称"
					name="version_name"
					width="130"
				>
				</c-table-column>

				<c-table-column
					label="状态"
					name="is_enabled"
					width="130"
				>
                  <template #default="{data}">
                    <c-switch v-if="auth('b_version_edit')" v-model="data.is_enabled" :state-value="[1, 2]" :state-text="['启用','禁用']"
                              @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                    <c-state v-else dict="disableEnableDic" :value="data.is_enabled"></c-state>
                  </template>
				</c-table-column>

				<c-table-column
					label="ICON"
					name="icon_img_url"
					width="130"
				>
                  <template #default="{data}">
                      <c-file v-if="data.icon_img_url" class="image" :src="data.icon_img_url" media style="width:40px;height:40px;"></c-file>
                      <span v-else>-</span>
                  </template>
				</c-table-column>

				<c-table-column
					label="背景图"
					name="is_enabled"
					width="130"
				>
                    <template #default="{data}">
                        <c-file v-if="data.background_img_url" class="image" :src="data.background_img_url" media style="width:65px;height:65px;"></c-file>
                        <span v-else>-</span>
                    </template>
				</c-table-column>

				<c-table-column
					label="说明"
					name="version_desc"
					width="500"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="200"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_version_edit')" icon="tf-edit" @click="$refs.versionEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_version_auth')" icon="tf-auth" @click="$refs.versionMenuEdit.open(data , 0)">电脑端权限</c-table-button>
						<c-table-button v-if="auth('b_version_auth')" icon="tf-auth" @click="$refs.versionMenuEdit.open(data , 1)">移动端权限</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--编辑版本菜单权限弹窗-->
			<version-menu-edit ref="versionMenuEdit" @resolve="$refs.list.update()"></version-menu-edit>
			<!--编辑版本弹窗-->
			<version-edit ref="versionEdit" @resolve="$refs.list.update()"></version-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import versionMenuEdit from "@/pages/saas/version_menu_edit.vue";
	import versionEdit from "@/pages/saas/version_edit.vue";

	export default {
		components: {
			versionMenuEdit,versionEdit
		},
		computed: {
      ...mapState(['disableEnableDic'])
    },
		props: {
			
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/sys_saas/version/list',
					data
				});
			},
            /******启禁用*********/
            stateHandle(state, next, data) {
            this.request({
              url: '/sys_saas/version/update_state',
              data: {
                version_id: data.id,
                is_enabled: state ? 2 : 1
              },
              success: () => {
                this.$message({
                  message:'操作成功',  // 提示内容,
                  type: 'success'
                });
                next();
              }
            })
          },
		}
	}
</script>

<style lang="stylus" scoped>
</style>